
import { useState } from 'react';
import ContactModal from './ContactModal';

export default function Footer() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <>
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            
            {/* Logo and Description */}
            <div className="md:col-span-1">
              <div className="flex items-center mb-4">
                <img 
                  src="https://static.readdy.ai/image/b390f97f5193aad98f2cacc0dec0dc30/a00bcf0a7bc469df8835f2ef80dfd14b.png" 
                  alt="The Maple Leaf Review Logo" 
                  className="w-32 h-32 object-contain"
                />
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                Celebrating Canadian literature from coast to coast to coast. Discover exceptional books and authors that define our nation's literary landscape.
              </p>
            </div>

            {/* Explore */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Explore</h3>
              <ul className="space-y-2">
                <li><a href="/reviews" className="text-gray-300 hover:text-red-400 cursor-pointer">Book Reviews</a></li>
                <li><a href="#" className="text-gray-300 hover:text-red-400 cursor-pointer">Author Interviews</a></li>
                <li><a href="#" className="text-gray-300 hover:text-red-400 cursor-pointer">Fiction</a></li>
                <li><a href="#" className="text-gray-300 hover:text-red-400 cursor-pointer">Non-Fiction</a></li>
              </ul>
            </div>

            {/* Contribute */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Contribute</h3>
              <ul className="space-y-2">
                <li><a href="/submit" className="text-gray-300 hover:text-red-400 cursor-pointer">Submit Your Work</a></li>
                <li><a href="#" className="text-gray-300 hover:text-red-400 cursor-pointer">Review Guidelines</a></li>
                <li>
                  <button 
                    onClick={() => setIsContactModalOpen(true)}
                    className="text-gray-300 hover:text-red-400 cursor-pointer text-left"
                  >
                    Contact Editors
                  </button>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Stay Updated</h3>
              <p className="text-gray-300 text-sm mb-4">
                Get the latest reviews and literary news delivered to your inbox.
              </p>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded-l-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                />
                <button className="px-4 py-2 bg-red-600 text-white rounded-r-md hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-mail-send-line"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Canadian Literary Review. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 sm:mt-0">
              <a href="#" className="text-gray-400 hover:text-red-400 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-red-400 cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-red-400 cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

        </div>
      </footer>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </>
  );
}
